import { render, staticRenderFns } from "./showStudentExams.vue?vue&type=template&id=58c88280&scoped=true&"
import script from "./showStudentExams.vue?vue&type=script&lang=js&"
export * from "./showStudentExams.vue?vue&type=script&lang=js&"
import style0 from "./showStudentExams.vue?vue&type=style&index=0&id=58c88280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c88280",
  null
  
)

export default component.exports